/* eslint-disable */
<template>
  <!--################### SLIDER SECTION #################-->
  <div id="slider">
    <div id="headerSlider" class="carousel slide carousel-fade" data-ride="carousel">
      <ol class="carousel-indicators">
        <li data-target="#headerSlider" data-slide-to="0" class="active"></li>
        <li data-target="#headerSlider" data-slide-to="1"></li>
        <li data-target="#headerSlider" data-slide-to="2"></li>
      </ol>
      <div class="carousel-inner">
        <div class="carousel-item active">
          <img src="../assets/img/bb5.jpg" class="d-block w-100" />
          <div class="carousel-caption">
            <h1 class="mb-4 carl-title">BEST WINTER COLLECTION FOR YOU</h1>
            <router-link to="/trends" class="btn btn-outline-light btn-lg">SHOP NOW</router-link>
          </div>
        </div>
        <div class="carousel-item">
          <img src="../assets/img/jeans5.jpg" class="d-block w-100" />
          <div class="carousel-caption">
            <h1 class="mb-4 carl-title">LATEST TREND ON CLOTHING</h1>
            <router-link to="/trends" class="btn btn-outline-light btn-lg">BUY NOW</router-link>
          </div>
        </div>
        <div class="carousel-item">
          <img src="../assets/img/mw3.jpg" class="d-block w-100" />
          <div class="carousel-caption">
            <h1 class="mb-4 carl-title">GET A STYLISH OUTFIT FOR YOURSELF</h1>
            <router-link to="/trends" class="btn btn-outline-light btn-lg">GET IT NOW</router-link>
          </div>
        </div>
      </div>
      <a class="carousel-control-prev" href="#headerSlider" role="button" data-slide="prev">
        <span class="carousel-control-prev-icon" aria-hidden="true"></span>
        <span class="sr-only">Previous</span>
      </a>
      <a class="carousel-control-next" href="#headerSlider" role="button" data-slide="next">
        <span class="carousel-control-next-icon" aria-hidden="true"></span>
        <span class="sr-only">Next</span>
      </a>
    </div>
  </div>
</template>

<script>
export default {
  name: "BannerCarousel"
};
</script>

<style></style>
